import { render, staticRenderFns } from "./successNomination.vue?vue&type=template&id=3781e5d8&scoped=true"
import script from "./successNomination.vue?vue&type=script&lang=js"
export * from "./successNomination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3781e5d8",
  null
  
)

export default component.exports